
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Forms/SearchBar.html",
      function () {
        return require("private-next-pages/Forms/SearchBar.html.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Forms/SearchBar.html"])
      });
    }
  